export let device;

//スマートフォン版幅幅取得
export const BREAK_POINT = 768;
export const MEDIA_QUERY_LIST = window.matchMedia('screen and (max-width: '+BREAK_POINT+'px)');


/**
 * デバイス別にイベントを返す
 * @param {*イベント} e
 * @return {*イベント} event
 */
export const initEvents = (e) => {
  let event;
  switch(e.type){
    case 'mousedown':
    case 'mousemove':
    case 'mouseup':
    case 'pointerdown':
    case 'pointermove':
    case 'pointerup':
      event = e;
      e.preventDefault();
      break;
    case 'touchstart':
    case 'touchmove':
    case 'touchend':
      event = e.changedTouches[0];
      break;
  }

  return event;
};


/**
 * レスポンシブ対応
 */
//ウィンドウ幅取得
var windowW = (window.innerWidth) ? window.innerWidth : document.documentElement.clientWidth;

//初期のウィンドウ幅での切替
deviceChange();

/**
 * DOMContentLoaded
 */
document.addEventListener('DOMContentLoaded',() =>{
  /**
     * リサイズイベント
     */
  window.addEventListener('resize',() =>{
    //ウィンドウ幅のリサイズ時の切替
    windowW = (window.innerWidth) ? window.innerWidth : document.documentElement.clientWidth;
    deviceChange();
  },false);
});


/**
 * ウィンドウ幅ごとの切替
 */
function deviceChange(){
  let oldDevice = device;

  // PC
  if(windowW > BREAK_POINT){
    if(device == 'pc') return;

    // 各種メニューのリセット
    let modal = document.querySelectorAll('.modal');
    for(let elem of  modal){
      elem.removeAttribute('style');
    }
    let buttons = document.querySelectorAll('a[data-open*="#"]');
    for(let elem of  buttons){
      elem.classList.remove('opened');
    }

    device = 'pc';

    // スマートフォン
  }else if(windowW <= BREAK_POINT){
    if(device == 'sp') return;

    device = 'sp';
  }

  if(oldDevice == device) return;

  // デバイスの変更があった際にアコーディオンメニューを初期化する
  const accordions = document.querySelectorAll('.accordion_close,.accordion_open');
  for(let accordion of accordions){
    const enableDevice = accordion.dataset.device;
    if(enableDevice == undefined) continue;

    if(enableDevice != device){
      accordion.nextElementSibling.removeAttribute('style');
      continue;
    }

    if(accordion.classList.contains('accordion_close')){
      accordion.nextElementSibling.style.display = 'none';
    }else if(accordion.classList.contains('accordion_open')){
      accordion.nextElementSibling.style.display = '';
    }
  }
}